import { ISpecOffer } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers';

import { IAction } from '~/src/store';

import { ESpecOfferActionTypes } from './constants';

export const setSelectedOfferId = (state: ISpecOffer['requestId']): IAction<ESpecOfferActionTypes.setSelectedOfferId, ISpecOffer['requestId']> => ({
    type: ESpecOfferActionTypes.setSelectedOfferId,
    payload: state,
});
